import { render, staticRenderFns } from "./SCookieBanner.vue?vue&type=template&id=d1acef9a&scoped=true"
import script from "./sCookieBanner.ts?vue&type=script&lang=ts&external"
export * from "./sCookieBanner.ts?vue&type=script&lang=ts&external"
import style0 from "./SCookieBanner.vue?vue&type=style&index=0&id=d1acef9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1acef9a",
  null
  
)

export default component.exports